import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { Container, Box, Tab, Tabs, Grid, Divider } from '@mui/material'

import api from 'api'
import Navbar from 'components/Common/Navbar'
import { store } from 'reduxStore'
import { greyPieChartColor, tealPieChartColor } from 'themes/theme'
import MainLayout from 'layouts/mainLayout'
import Payment from 'components/MyAccount/NewPayment'
import Security from 'components/MyAccount/Security'
import MyProfile from 'components/MyAccount/MyProfile'
import Subscription from 'components/MyAccount/Subscription'

import routes from 'routes'

import TabPanel from 'components/Common/TabPanel'
import { a11yProps } from 'components/Common/TabPanel'

import './styles.css'
import sx from './styles'
import GradientCircularProgress from 'components/Common/GradientCircularProgress'

const tabName = {
  Myprofile: 0,
  security: 1,
  subscription: 2,
  Payment: 3,
  NewPayment: 4,
}


const MyAccount = props => {
  const [value, setValue] = React.useState(0)

  const user = store.getState().userReducer.user

  const dashboardInfo = useSelector(state => state.apiResponseReducers.dashboardInfo)

  const [isChartLoading, setIsChartLoading] = useState(true)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  searchParams.get('tab')

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [navigate])

  useEffect(() => {
    if (searchParams.get('tab')) {
      const selectedTab = tabName[searchParams.get('tab')] || 0
      setValue(selectedTab)
    }
  }, [searchParams])

  const handleChange = (event, newValue) => {
    const selectedTab = Object.keys(tabName).find(t => tabName[t] === newValue)
    navigate({
      pathname: '/my-account',
      search: `?tab=${selectedTab}`,
    })
  }

  useEffect(() => {
    if (!user) return

    fetchCharData()
  }, [user])

  const fetchCharData = async () => {
    await api.getDashboardInfo()
    setIsChartLoading(false)
  }

  const userProfileCompletion = dashboardInfo?.user_info?.profile_completion
    ? parseInt(dashboardInfo?.user_info?.profile_completion)
    : 0

  const userChartData = [
    {
      share: dashboardInfo?.user_info?.profile_completion ? parseInt(dashboardInfo?.user_info?.profile_completion) : 0,
      color: tealPieChartColor,
    },
    {
      share:
        100 -
        (dashboardInfo?.user_info?.profile_completion ? parseInt(dashboardInfo?.user_info?.profile_completion) : 0),
      color: greyPieChartColor,
    },
  ]

  if (!user) {
    return <Navigate to={routes.auth.signIn} />
  }

  return (
    <MainLayout>
      <Navbar isDashboard={false} />
      <div className="container-fluid">
        <div className="row">
          <main>
            <Container maxWidth="lg">
              <Box
                mt={4}
                sx={{
                  display: 'grid',
                  gridAutoColumns: '1fr',
                  gap: 1,
                }}
              >
                <Grid item sx={{ gridRow: '1', gridColumn: 'span 2', marginBottom: '-10px' }} className="Krishna">
                  <Grid container flexDirection="column">
                    <Grid item>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 'bold',
                            fontSize: '20px',
                            display: 'flex',
                            color: 'var(--primary)',
                            fontFamily: 'poppins',
                            letterSpacing: '-0.3px',
                            lineHeight: '36px',
                            marginBottom: '20px',
                          }}
                        >
                          My Account
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="basic tabs example"
                      allowScrollButtonsMobile={true}
                      textColor="primary"
                      TabIndicatorProps={{
                        style: { display: 'none' },
                      }}
                      sx={sx.tabs}
                    >
                      <Tab disableFocusRipple={true} className="nav-item" label="My Profile" {...a11yProps(0)} />
                      <Tab disableFocusRipple={true} label="Security" {...a11yProps(1)} />
                      <Tab disableFocusRipple={true} label="Subscription" {...a11yProps(2)} />
                      <Tab disableFocusRipple={true} label="Payment" {...a11yProps(3)} />
                    </Tabs>
                  </Grid>
                </Grid>

                <Grid item sx={{ gridRow: '1', gridColumn: '4 / 5' }}>
                  <Grid container flexDirection="column" alignItems="center">
                    <Grid item>
                      {userChartData && !isChartLoading && (
                        <GradientCircularProgress
                          size="small"
                          value={userProfileCompletion}
                          title={'User Profile'}
                          sx={{ marginRight: '30px' }}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  marginBottom: '20px',
                }}
              ></Box>
              <Box sx={{ width: '100%' }}>
                <Divider sx={{ marginTop: 0, marginBottom: '10px' }} />
                <TabPanel value={value} index={0}>
                  <MyProfile />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Security />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <Subscription />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <Payment />
                </TabPanel>
                {/* <TabPanel value={value} index={4}> */}
                {/* <AlertsTab /> */}
                {/* </TabPanel> */}
              </Box>
            </Container>
          </main>
        </div>
      </div>
    </MainLayout>
  )
}

export default MyAccount
